/****************************************************************
	Responsive tabs class
****************************************************************/
var tab_accordion = tab_accordion || {};
tab_accordion = function ( merge_options ) {
	//Default Private Properties
	var defaults = {		
		root_name: ".accordion-group",
		accordion_name: ".accordion",
		tab_name: ".tabs",
		animation_speed: 250,
		ga: true,
		page_url: document.location.protocol +"//"+ document.location.hostname + document.location.pathname
	}

	//Merge external options with defaults - Example usage options.someproperty;
	var options = jQuery.extend(defaults, merge_options);
	
	var t,
	root,
	href,
	tab,
	accordion,
	accordion_panel;
	
	var caller = false;
	var animation_speed = 0;
	var animation_type = false;
	
	//Private Methods	
	function _bind()
	{	
		jQuery(document).on("click", ".tabs > li > a, .accordion > dt > a", function(e) {
			t = jQuery(this);
			_clicked(true);
			return false;
		});
		
		jQuery(document).on("click-no-replace-state", ".tabs > li > a, .accordion > dt > a", function(e) {
			t = jQuery(this);
			_clicked(false);			
			return false;
		});
	}
	
	function _clicked(replace_state)
	{
		_set_variables();
		_get_caller();
		_select_panel();
		_animate_panel();
		if(replace_state == true)
		{
			_set_replace_state();
		}
		_ga();
	}
	
	function _set_variables()
	{		
		root = t.closest(options.root_name);
		href = t.attr("href");
		tab = root.find(options.tab_name+" > li > a[href='"+href+"']").closest("li");
		accordion = root.find(options.accordion_name+" > dt > a[href='"+href+"']").closest("dt");
		accordion_panel = accordion.next("dd");
	}
	
	function _get_caller()
	{
		if(t.parent().is("dt"))
		{
			caller = options.accordion_name;
		}
		
		if(t.parent().is("li"))
		{
			caller = options.tab_name;
		}
	}
	
	function _select_panel()
	{		
		if((root.hasClass("accordion--multiple") && caller == options.accordion_name))
		{
			tab.toggleClass("selected");
			accordion.toggleClass("selected");
			animation_type = "slidetoggle";
			animation_speed = options.speed;
		} else {
			if(!tab.hasClass("selected") || !accordion.hasClass("selected"))
			{
				//View one at a time - nth = root.find(".accordion > dt").index( t.closest("dt") );
				root.find("> "+options.tab_name+" > li").removeClass("selected");
				root.find("> "+options.accordion_name+" > dt").removeClass("selected");
				root.find("> "+options.accordion_name+" > dd").removeClass("selected").hide();
	
				tab.addClass("selected");
				accordion.addClass("selected");
				
				if(caller == options.tab_name && root.attr("data-tabs-animation"))
				{
					animation_speed = options.animation_speed;
					animation_type = root.attr("data-tabs-animation");
				}
				
				if(caller == options.accordion_name && root.attr("data-accordion-animation"))
				{
					animation_speed = options.animation_speed;
					animation_type = root.attr("data-accordion-animation");
				}
			}
		}
		
		root.find("> "+options.accordion_name+" > dd img.unveil").trigger("unveil");
	}
	
	function _animate_panel()
	{
		switch(animation_type)
		{
		case "slide":
			accordion_panel.slideDown(animation_speed, function(){
				jQuery(this).addClass("selected");
			});
			break;
		case "fade":
			accordion_panel.fadeIn(animation_speed, function(){
				jQuery(this).addClass("selected");
			});
			break;
		case "slidetoggle":
			accordion_panel.slideToggle(animation_speed, function(){
				jQuery(this).toggleClass("selected").removeAttr("style");
			});
			break;
		default:
			accordion_panel.fadeIn(animation_speed, function(){
				jQuery(this).addClass("selected");
			});
		}
	}
	
	function _set_replace_state()
	{
		if(window.history.replaceState)
		{
			var url = t.attr("href");
			url = options.page_url + url;			
			window.history.replaceState("site", "", url);
		}
	}
	
	function _set_tab()
	{
		jQuery(window).load(function(e) {
			var hash = window.location.hash;
			var tab_target = jQuery(options.root_name + " a[href='"+hash+"']:first");
			if(tab_target.hasClass("selected") == false)
			{
				tab_target.one().trigger("click");
			}
		});
	}
	
	function _ga()
	{
		ga_event({
			"category": "accordion",
			"action": "click",
			"label": href,
			"value": 1
		});
	}
	
	//Public properties and methods.
	return {
		init: function() {
			_bind();
			_set_tab();
		}
	};
};

/****************************************************************
	Responsive Tabs
****************************************************************/
var tab_accordion_object = new tab_accordion();	
tab_accordion_object.init();